import React from 'react';
import { Icon } from './Icon';

const DwellIcon = ({ size }: Props) => {
  return (
    <Icon type="clock-hour-4" color="bg-label-warning" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { DwellIcon };